// @flow
import type { List, Map } from "immutable";

export default function findCurrentRaceIndex(races: List<Map<string, any>>): ?number {
  var raceStatuses = races.map((race) => race.get("status")).toJS();
  for (var i = raceStatuses.length - 1; i >= 0; i--) {
    if (raceStatuses[i] === "running" || (
      i < raceStatuses.length - 1 &&
      raceStatuses[i] === "final" &&
      raceStatuses[i + 1] === "open"
    )) {
      return i;
    }
  }
  return undefined;
}
